import React from 'react';
import './sectionVideo.css';

function SectionVideo() {
  return (

    <div className="section-content-video">
      <video width="100%" poster="images/thum-video-claropay.png" controls>
        <source src="video/ClaroPay_Que_es.mp4" type="video/mp4" />
      </video>
    </div>

  );
}

export default SectionVideo;